import { isCountryHighRisk } from '../lib/validation-helper';
import * as z from 'zod';



export const RegisterSchema = z
  .object({
    // Many international students do not have a first name,
    // so we make this optional otherwise they will enter invalid
    // data like a dot to bypass validation
    firstName: z.string().min(1, { message: 'Enter first name' }),
    lastName: z.string().min(1, { message: 'Enter last name' }),
    email: z.string().email({ message: 'Enter a valid email address' }),
    gender: z.string().min(1, { message: 'Select your gender' }),
    dob: z.union([z.date(), z.null()]).superRefine((value: Date | null, ctx: z.RefinementCtx) => {
      if (value === null) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Select your date of birth' });
        return;
      }

      /* Student Admissions has decided to remove the minimum age requirement for students, so we no longer need to validate this.
      //const MINIMUM_AGE = 14;
      // const minAge = new Date();
      // minAge.setFullYear(minAge.getFullYear() - MINIMUM_AGE);
      // if (value > minAge) {
      //   ctx.addIssue({ code: z.ZodIssueCode.custom, message: `You must be at least ${MINIMUM_AGE} years old` });
      // }
      */
    }),
    citizenship: z.string().min(1, { message: 'Select your citizenship or residency status' }),
    countryOfCitizenship: z.string().min(1, { message: 'Enter country of citizenship' }),
    isHdr: z.string().optional(),
    isAustralianVisa: z.string().optional(),
  })
  .refine(
    // Validation for isHdr - must have a value if countryOfCitizenship is high risk
    (schema) => !isCountryHighRisk(schema.citizenship, schema.countryOfCitizenship) || schema.isHdr,
    { message: 'Enter whether you are applying for HDR or Study Exchange Program (NA-EXCHN)', path: ['isHdr'] },
  )
  .refine(
    // Validation for isAustralianVisa - must have a value if isHdr is false
    (schema) =>
      !isCountryHighRisk(schema.citizenship, schema.countryOfCitizenship) ||
      schema.isHdr === 'true' ||
      schema.isAustralianVisa,
    { message: 'Enter whether you have a valid Australian Visa', path: ['isAustralianVisa'] },
  );
